import { getUserObject } from '../Shared/scriptts/session/sessionmain';
import { logEvent } from '../Shared/scriptts/analytics';

document.addEventListener('DOMContentLoaded', () => {
    bindEvents();
    setSessionContent();
});

function bindEvents() {
    document.querySelector<HTMLElement>('#landing-profile-link')?.addEventListener('click', profileLinkClicked);
}

function profileLinkClicked(evt: Event) {
    const elem = (<HTMLElement>evt.target);
    logEvent('link', 'select', true, elem);
}

function setSessionContent() {
    const heroProfileLink = document.querySelector<HTMLElement>('#landing-profile-link');
    const heroLoginLink = document.querySelector<HTMLElement>('#landing-login-link');
    const isAuthenticated = getUserObject().IsAuthenticated;
    
    if (heroProfileLink !== null) {
        heroProfileLink.innerText = isAuthenticated === true ? "View profile" : "Create profile";
        heroProfileLink.setAttribute('data-ga-label', isAuthenticated ? 'viewprofile' : 'createprofile');
    }
    if (heroLoginLink !== null) {
        heroLoginLink.hidden = isAuthenticated === true;
    }
}
